import { render } from "./RestoreAttachBackupVolume.vue?vue&type=template&id=c27c303c&scoped=true"
import script from "./RestoreAttachBackupVolume.vue?vue&type=script&lang=js"
export * from "./RestoreAttachBackupVolume.vue?vue&type=script&lang=js"

import "./RestoreAttachBackupVolume.vue?vue&type=style&index=0&id=c27c303c&scoped=true&lang=less"

import exportComponent from "/mnt/build/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c27c303c"]])

export default __exports__